import { useContext, useState } from "react";
import RequiredDocumentsModal from "../onboarding/RequiredDocumentsModal";
import MissingDocument from "../onboarding/missingDocument";
import TenantContext from "../../context/tenant/TenantContext";
import useDocumentAnalysis from "../../hooks/useDocumentAnalysis";

const STEP_TO_NUMBER = {
  checks: 1,
  basic: 2,
  identity: 3,
  documents: 5,
  financial: 6,
  guarantor: 4,
};

const TenantChecksUploadDocument = ({
  formHandler,
  user,
  updateUserProfile,
  getNextStep,
  onComplete,
  selectedOnboardingUsers,
  setSelectedOnboardingUsers,
}) => {
  const [showMissing, setShowMissing] = useState(false);
  const { checkDocumentAnalysisStatus } = useContext(TenantContext);
  // Same single-cache rule as onboarding: fetch once, reuse, refresh on upload.
  const {
    analysis: documentAnalysisResponse,
    status: documentAnalysisStatus,
    loading: docAnalysisLoading,
    refresh: refreshDocumentAnalysis,
  } = useDocumentAnalysis(user?._id, checkDocumentAnalysisStatus);

  const advanceToNextStep = async () => {
    const nextId = getNextStep();
    if (!nextId) {
      await onComplete();
      return;
    }
    await updateUserProfile({
      id: user?._id,
      step: STEP_TO_NUMBER[nextId] ?? nextId,
    });
    formHandler.next();
  };

  if (showMissing) {
    return (
      <MissingDocument
        documentAnalysisResponse={documentAnalysisResponse}
        docAnalysisLoading={docAnalysisLoading}
        documentAnalysisStatus={documentAnalysisStatus}
        refreshDocumentAnalysis={refreshDocumentAnalysis}
        user={user}
        formHandler={{
          prev: () => setShowMissing(false),
          next: advanceToNextStep,
        }}
        selectedOnboardingUsers={selectedOnboardingUsers}
        setSelectedOnboardingUsers={setSelectedOnboardingUsers}
        updateUserProfile={updateUserProfile}
        isGuarantor={false}
        isEditMode={false}
        usedFor="tenantChecks"
      />
    );
  }

  return (
    <RequiredDocumentsModal
      user={user}
      formHandler={{ ...formHandler, next: () => setShowMissing(true) }}
      updateUserProfile={() => setShowMissing(true)}
      documentAnalysisResponse={documentAnalysisResponse}
      refreshDocumentAnalysis={refreshDocumentAnalysis}
      isGuarantor={false}
      needWaitingJobForClave={false}
      isEditMode={false}
      hideClave
      llCreated
      onClose={formHandler.prev}
    />
  );
};

export default TenantChecksUploadDocument;
